/**
 * Default authentication provider for SharePoint.
 *
 * In the most common deployment — pages hosted by SharePoint itself — auth
 * is handled transparently by the browser session (NTLM/Kerberos/SAML
 * cookies via `credentials: 'include'`), so this provider returns empty
 * headers and the default behaviour is correct.
 *
 * Override `authProvider` on `SharePointClient` only when hosting elsewhere
 * (Add-in token, Basic auth, custom bearer, ...) by passing an async
 * function that resolves to a headers object.
 *
 * @returns {Promise<object>} Authentication headers
 */
export async function getSharePointAuthHeaders() {
  return {};
}
